import type { RoomList } from "@/lib/gql/__generated__/graphql";

import type { DnDResultItem } from "@/hooks/use-dnd/use-dnd";
import { useCustomMutation } from "@/hooks/use-graphql-client";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info/_hooks/use-toast";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { UpdateRoomListMutation } from "./mutation";

type Props = {
	hotelID: string;
	dndItemList: Array<DnDResultItem<RoomList["rooms"][number]>>;
};

export const useSortRoomList = ({ hotelID, dndItemList }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const { mutationFunc: updateRoomList } = useCustomMutation(UpdateRoomListMutation);

	const onSaveSort = async () => {
		showLoadingScreenCallback();
		const { errors } = await updateRoomList({
			variables: {
				input: {
					hotelID,
					rooms: dndItemList.map((result) => result.value.roomID),
				},
			},
		}).finally(() => hideLoadingScreenCallback());

		if (!errors) {
			notifyUserEventInfo({
				title: "部屋の並び替えを保存しました",
			});
		}
	};

	return { onSaveSort };
};
